import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { TextField } from 'shared/form-fields';
import { Button, LoadingIcon } from 'shared';
import * as validators from 'services/fields/field-validators';
import local from 'services/localization/local';

import { getAuthConnection, resetConnection, loading } from 'auth-connections/auth-connection-actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { signIn } from '../../identity/action-creators';
import { authConnection } from 'auth-connections/auth-connection-selectors';

class RegisterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false
    };
    this.showOrHidePassword = this.showOrHidePassword.bind(this);
    this.reset = this.reset.bind(this);
    this.checkConnection = this.checkConnection.bind(this);
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.resetConnection();
  }

  componentWillUnmount() {
    const { change, untouch } = this.props;
    change('password', null);
    untouch('password');
  }

  showOrHidePassword() {
    this.setState({
      showPassword: this.state.showPassword ? false : true
    });
  }

  checkConnection(event) {
    const { actions } = this.props;
    if (event && event.email && event.email.length > 0) {
      this.setState({ email: event.email });
      const domain = event.email.substring(event.email.lastIndexOf('@') + 1);
      actions.getAuthConnection(domain);
    }
  }

  reset() {
    const { actions } = this.props;
    actions.resetConnection();
  }

  render() {
    const { handleSubmit, pristine, registering, submitting, privacyPolicySection, authConnection, actions, isFromProvider } = this.props;
    const isRegistering = registering || submitting || authConnection.loading;
    const isSubmitDisabled = pristine || registering;
    var icon = <i className={this.state.showPassword ? 'fa fa-eye fa-eye-slash eye-slash-icon' : 'fa fa-fw fa-eye eye-icon'} onClick={this.showOrHidePassword}></i>;
    if (authConnection && authConnection.connection && authConnection.connection.length > 0) {
      actions.signIn(this.state.email, null, authConnection.connection);
    }
    return (
      <form className="p-0" onSubmit={authConnection.connectionNotFound ? handleSubmit : handleSubmit(this.checkConnection)} >
        <div className='edit-inputType-register-wrapper'>
          <Field
            label={local.formEmailLabel}
            name="email"
            type="email"
            autoComplete="username email"
            component={TextField}
            disabled={authConnection.connectionNotFound}
            validate={[validators.required, validators.email]} />
          {authConnection.connectionNotFound &&
            <Button
              id="editButton"
              onClick={this.reset}
              color="transparent"
              className="edit-inputType-btn">
              {local.edit}
            </Button>}
        </div>
        {authConnection.loading && <LoadingIcon />}
        {(authConnection.connectionNotFound) && <Field
          label={local.formPasswordRequirementLabel}
          name="password"
          component={TextField}
          type={this.state.showPassword ? "text" : "password"}
          autoComplete="new-password"
          disabled={isRegistering}
          validate={[validators.required, validators.minLength8]}
          children={icon} />}
        <br />
        <Button
          id="registerSubmitButton"
          submit
          disabled={isSubmitDisabled}
          color="blue"
          className="w-100 mb-4">
          {authConnection.connectionNotFound ? (isFromProvider ? local.joinCalcium : local.join) : local.formContinueButton}
        </Button>
        <br />
        { !isFromProvider ? '' : authConnection.connectionNotFound && privacyPolicySection}
      </form>
    );
  }
}

RegisterForm.displayName = 'RegisterForm';
RegisterForm.propTypes = {
  registering: PropTypes.bool.isRequired,
  privacyPolicySection: PropTypes.node.isRequired,
  // redux form
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  untouch: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
  const actions = { getAuthConnection, signIn, resetConnection, loading };
  return { actions: bindActionCreators(actions, dispatch) };
}
function mapStateToProps(state) {
  return {
    authConnection: authConnection(state),
    unverifiedEmail:state.identity.unverifiedEmail
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'signin-register-reset',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(RegisterForm));




// import React from 'react';
// import PropTypes from 'prop-types';
// import { Field, reduxForm } from 'redux-form';
// import { TextField } from 'shared/form-fields';
// import { Button, LoadingIcon } from 'shared';
// import * as validators from 'services/fields/field-validators';
// import local from 'services/localization/local';
// import { getAuthConnection, resetConnection, loading } from 'auth-connections/auth-connection-actions';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
// import { signIn, onboardOrg, onBoard, checkEmailExists } from '../../identity/action-creators';
// import { authConnection } from 'auth-connections/auth-connection-selectors';
// import { withRouter } from 'react-router-dom';
// import AgreementSteps from 'shared/AgreementSteps/AgreementSteps';
// import Header from '../../components/header/Header';

// // Import the AgreementSteps component from your shared module // This assumes your shared/index.js exports it as 'AgreementSteps'


// // Helper function to get city/state from ZIP code
// const getCityStateFromZip = async (zip) => {
//   try {
//     const response = await fetch(`https://api.zippopotam.us/us/${zip}`);
//     if (!response.ok) return null;

//     const data = await response.json();
//     const place = data.places[0];

//     return {
//       city: place["place name"],
//       state: place["state abbreviation"],
//       country: data.country
//     };
//   } catch (err) {
//     console.error("Error fetching ZIP info:", err);
//     return null;
//   }
// };

// class RegisterForm extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       errorMessage: '',
//       successMessage: '',
//       showPassword: false,
//       currentStep: 1,
//       isLoading: false,
//       step1Data: null,
//       step2Data: null,
//       step3Data: null,
//       existEmailMessage: '',
//       showAgreement: false,
//       agreementDetails: null,
//     };
//   }

//   componentDidMount() {
//     this.props.actions.resetConnection();
//   }

//   componentWillUnmount() {
//     const { change, untouch } = this.props;
//     change('password', null);
//     untouch('password');
//   }

//   componentDidUpdate(prevProps, prevState) {
//     const { currentStep, step1Data } = this.state;

//     if (currentStep === 3 && prevState.currentStep !== 3 && step1Data) {
//       const fullName = `${step1Data.firstName || ''} ${step1Data.lastName || ''}`.trim();
//       this.props.change('providerName', fullName);
//     }
//   }

//   showOrHidePassword = () => {
//     this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
//   };

//   handleNextStep = async () => {
//     const { handleSubmit, pristine, submitting } = this.props;
//     const { currentStep } = this.state;

//     if (pristine || submitting) return;

//     this.setState({ isLoading: true });

//     try {
//       switch (currentStep) {
//         case 1:
//           await this.handleStep1(handleSubmit);
//           break;
//         case 2:
//           await this.handleStep2(handleSubmit);
//           break;
//         case 3:
//           await handleSubmit(async (values) => {
//             this.setState({ step3Data: values, showAgreement: true });
//           })();
//           break;
//         default:
//           break;
//       }
//     } catch (error) {
//       console.error('Error in API calls during step transition:', error);
//       this.setState({ isLoading: false, errorMessage: 'An error occurred during step transition. Please try again.' });
//     } finally {
//       if (currentStep !== 3 || !this.state.showAgreement) {
//           this.setState({ isLoading: false });
//       }
//     }
//   };

//   handleZipChangeStep2 = async (event) => {
//     const zip = event.target.value.replace(/\D/g, '').slice(0, 5);
//     this.props.change('zipCode', zip);

//     if (zip.length === 5) {
//       const result = await getCityStateFromZip(zip);
//       if (result) {
//         this.props.change('city', result.city);
//         this.props.change('state', result.state);
//         this.props.change('country', result.country);
//       }
//     } else {
//       this.props.change('city', '');
//       this.props.change('state', '');
//       this.props.change('country', '');
//     }
//   };

//   handleProviderZipChange = async (event) => {
//     const zip = event.target.value.replace(/\D/g, '').slice(0, 5);
//     this.props.change('providerZipCode', zip);

//     if (zip.length === 5) {
//       const result = await getCityStateFromZip(zip);
//       if (result) {
//         this.props.change('providerCity', result.city);
//         this.props.change('providerState', result.state);
//         this.props.change('providerCountry', result.country);
//       }
//     } else {
//       this.props.change('providerCity', '');
//       this.props.change('providerState', '');
//       this.props.change('providerCountry', '');
//     }
//   };

//   handleStep1 = async (handleSubmit) => {
//     await handleSubmit(async (values) => {
//       const { email, firstName, lastName, phoneNumber, password } = values;
//       this.setState({ existEmailMessage: '' });

//       try {
//         const emailExistsResponse = await this.props.actions.checkEmailExists(email);
//         console.log('API Response for email check:', emailExistsResponse);

//         if (emailExistsResponse === true) {
//           this.setState({ existEmailMessage: 'Email already exists. Please use another email.' });
//           return;
//         }

//         const requestData = { firstName, lastName, phoneNumber, email, password };
//         const step1Response = await this.props.actions.onboardOrg(requestData);
//         localStorage.setItem('userEmail', JSON.stringify(step1Response.email));
//         this.setState({ currentStep: 2, step1Data: step1Response });
//       } catch (error) {
//         console.error('Error checking email or onboarding in Step 1:', error);
//         this.setState({ errorMessage: 'An unexpected error occurred during Step 1. Please try again.' });
//       }
//     })();
//   };

//   handleStep2 = async (handleSubmit) => {
//     await handleSubmit(async (values) => {
//       const { step1Data } = this.state;

//       if (!step1Data) {
//         console.error("Step 1 data missing, cannot proceed to Step 2 onboarding.");
//         this.setState({ errorMessage: "Missing contact information. Please go back to Step 1." });
//         return;
//       }

//       const requestData = {
//         email: step1Data.email,
//         password: step1Data.password,
//         firstName: step1Data.firstName,
//         lastName: step1Data.lastName,
//         phoneNumber: step1Data.phoneNumber,
//         companyName: values.companyName,
//         orgAddr1: values.orgAddr1,
//         orgAddr2: values.orgAddr2,
//         city: values.city,
//         state: values.state,
//         country: values.country,
//         zipCode: values.zipCode,
//       };

//       try {
//         console.log("Step 2 Request Data:", requestData);
//         // Assuming onboardOrg returns data useful for subsequent steps or confirmation
//         const step2Response = await this.props.actions.onboardOrg(requestData);
//         console.log("Step 2 Response:", step2Response);
//         // Store all relevant data from step 2, including values for next steps
//         this.setState({ currentStep: 3, step2Data: { ...requestData, onboardOrgResponse: step2Response } });
//       } catch (error) {
//         console.error("Error in Step 2:", error);
//         this.setState({ errorMessage: 'Error during organization onboarding in Step 2. Please try again.' });
//       }
//     })();
//   };

//   // NEW: This function will now be called AFTER the agreement is completed
//   handleFinalOnboarding = async () => {
//     const { step1Data, step2Data, step3Data, agreementDetails } = this.state;
//     const { onErrorMessage, onSuccessMessage } = this.props;

//     // Ensure all necessary data is present, including agreement details
//     if (!step1Data || !step2Data || !step3Data || !agreementDetails || !agreementDetails.agreed) {
//       console.error("Missing data for final onboarding. Cannot proceed.");
//       if (onErrorMessage) {
//         onErrorMessage('Missing data for final onboarding. Please complete all steps and agree to terms.');
//       }
//       this.setState({ isLoading: false }); // Ensure loading state is reset
//       return;
//     }

//     const providerData = {
//       email: step1Data.email, // Use email from step1Data
//       password: step1Data.password, // Use password from step1Data
//       firstName: step1Data.firstName,
//       lastName: step1Data.lastName,
//       phoneNumber: step1Data.phoneNumber,
//       companyName: step2Data.companyName,
//       orgAddr1: step2Data.orgAddr1,
//       orgAddr2: step2Data.orgAddr2,
//       city: step2Data.city,
//       state: step2Data.state,
//       country: step2Data.country,
//       zipCode: step2Data.zipCode,
//       providerName: step3Data.providerName,
//       providerNPI: step3Data.providerNPI,
//       providerAddress: step3Data.providerAddress,
//       providerCity: step3Data.providerCity,
//       providerState: step3Data.providerState,
//       providerZipCode: step3Data.providerZipCode,
//       // Add agreement details to the final payload if your API supports it
//       agreementTimestamp: agreementDetails.timestamp,
//       agreementIpAddress: agreementDetails.ipAddress,
//     };

//     try {
//       this.setState({ isLoading: true }); // Set loading state for final submission

//       // Final call to onboardOrg with all collected data
//       // Note: If onboardOrg handles *all* steps incrementally, this might be a final "update"
//       // or the first call for the full data. Adjust based on your backend API.
//       const step3Response = await this.props.actions.onboardOrg(providerData);
//       console.log("Final OnboardOrg Response:", step3Response);
//       localStorage.setItem('providerData', JSON.stringify(providerData)); // Store for debugging/future use

//       // Construct onboardData for the final 'onBoard' action (often a separate finalization step)
//       const onboardData = {
//         companyLocation: step3Response.providerState || providerData.providerState, // Use response if available, else local state
//         companyName: step3Response.orgName || providerData.companyName,
//         phoneNumber: step3Response.phoneNumber || providerData.phoneNumber,
//         dob: "2025-02-02", // Example, you might have a field for this in your form
//         gender: "Male", // Example, you might have a field for this in your form
//         email: step3Response.email || providerData.email,
//         firstName: step3Response.firstName || providerData.firstName,
//         howDidYouHearAboutCalcium: "Other", // Example
//         lastName: step3Response.lastName || providerData.lastName,
//         marketingSourceData: null,
//         numberOfEmployees: "70", // Example
//         password: step3Response.password || providerData.password,
//         solution: "ec18cad0-da35-453f-b33e-004f00d453f6" // Example
//       };
//       localStorage.setItem('onboardData', JSON.stringify(onboardData)); // Store for debugging/future use

//       const onboardResponse = await this.props.actions.onBoard(onboardData); // Final onboarding action

//       if (onSuccessMessage) {
//         onSuccessMessage('Provider onboarded successfully');
//       }

//       // Redirect to the Stripe payment page (or your specified path)
//       this.props.history.push({
//         pathname: '/plan-details',
//         state: { onboardData: onboardResponse } // Pass any relevant data
//       });

//     } catch (error) {
//       console.error("Final Onboarding Error:", error);
//       if (onErrorMessage) {
//         onErrorMessage('Provider onboarding failed');
//       }
//     } finally {
//       this.setState({ isLoading: false }); // Always reset loading state
//     }
//   };

//   handlePreviousStep = () => {
//     this.setState((prevState) => ({
//       currentStep: Math.max(1, prevState.currentStep - 1)
//     }));
//   };

//   // NEW: Handler for when the AgreementSteps component signals completion
//   handleAgreementComplete = (details) => {
//     this.setState({
//       agreementDetails: details, // Store the timestamp and IP address
//       showAgreement: false, // Hide the AgreementSteps component
//     }, () => {
//       this.handleFinalOnboarding(); // Proceed to the final onboarding logic
//     });
//   };

//   renderStep() {
//     const { currentStep } = this.state;

//     switch (currentStep) {
//       case 1:
//         return (
//           <div className='form-field-container'>
//             <h2 style={{}}>Business Contact Information</h2>
//             <Field label="First Name *" name="firstName" type="text" component={TextField} validate={[validators.required]} />
//             <Field label="Last Name *" name="lastName" type="text" component={TextField} validate={[validators.required]} />
//             <Field
//               label="Phone Number *"
//               name="phoneNumber"
//               type="tel"
//               component={TextField}
//               validate={[validators.phoneNumber]}
//               parse={value => value?.replace(/\D/g, '')?.slice(0, 10)}
//               props={{
//                 maxLength: 10,
//                 inputMode: 'numeric',
//                 pattern: '[0-9]{10}',
//                 onInput: (e) => {
//                   e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
//                 }
//               }}
//             />
//            <Field
//               label="Email *"
//               name="email"
//               type="email"
//               component={TextField}
//               validate={[
//                 validators.required,
//                 validators.email
//               ]}
//             />
//             {this.state.existEmailMessage && (
//               <div className="form-error-message">
//                 {this.state.existEmailMessage}
//               </div>
//             )}

//             <Field
//                label={local.formPasswordRequirementLabel + ' *'}
//               name="password"
//               component={TextField}
//               type={this.state.showPassword ? "text" : "password"}
//               autoComplete="new-password"
//               validate={[validators.required, validators.minLength8]}
//               children={<i className={this.state.showPassword ? 'fa fa-eye fa-eye-slash eye-slash-icon' : 'fa fa-fw fa-eye eye-icon'} onClick={this.showOrHidePassword}></i>} />
//           </div>
//         );

//       case 2:
//         return (
//           <div className='form-field-container'>
//             <h2>Organization Information</h2>
//             <p>As authorized users of Calcium Core can securely access and manage patient health data, including electronic health records and real-time insights.</p>

//             <Field label="Organization Name *" name="companyName" type="text" component={TextField} validate={[validators.required]} />
//             <Field label="Address 1 *" name="orgAddr1" type="text" component={TextField}  validate={[validators.required]}/>

//             <Field label="Address 2" name="orgAddr2" type="text" component={TextField} />
//             <Field
//               label="Zip Code *"
//               name="zipCode"
//               type="text"
//               component={TextField}
//               validate={[validators.validateZipCode]}
//               onChange={this.handleZipChangeStep2}
//             />

//             <Field label="City *" name="city" type="text" component={TextField}  validate={[validators.required]} />
//             <Field label="State * / Province" name="state" type="text" component={TextField}  validate={[validators.required]}/>
//             <Field label="Country*" name="country" type="text" component={TextField}  validate={[validators.required]}/>
//           </div>
//         );


//       case 3:
//         return (
//           <div className='form-field-container'>
//             <h2>Provider Information</h2>
//             <p>As the Calcium Core platform is designed for licensed healthcare providers to manage and monitor their patients' health data and progress, we will need to verify your provider status with an NPI number.</p>
//             <Field label="Full Name *" name="providerName" type="text" component={TextField}  validate={[validators.required]} />
//             <Field label="NPI Number *" name="providerNPI" type="tel" component={TextField}  validate={[validators.required]} />
//             <Field label="Address *" name="providerAddress" type="text" component={TextField}  validate={[validators.required]} />
//             <Field
//               label="Zip Code *"
//               name="providerZipCode"
//               type="text"
//               component={TextField}
//               onChange={this.handleProviderZipChange}
//                validate={[validators.required]}
//             />
//             <Field label="City *" name="providerCity" type="text" component={TextField}  validate={[validators.required]} />
//             <Field label="State * / Province" name="providerState" type="text" component={TextField}  validate={[validators.required]} />
//             <Field label="Country *" name="providerCountry" type="text" component={TextField}  validate={[validators.required]}/>
//           </div>
//         );

//       default:
//         return null;
//     }
//   }

//   render() {
//     const { handleSubmit, authConnection } = this.props;
//     const { isLoading, currentStep, showAgreement } = this.state;

//     // NEW: If showAgreement is true, render the AgreementSteps component instead of the form
//     if (showAgreement) {
//       return <AgreementSteps onAgreementComplete={this.handleAgreementComplete} />;
//     }

//     // Otherwise, render the multi-step registration form
//     return (
//       <form className="p-0" onSubmit={handleSubmit}>
//         <div className='edit-inputType-register-wrapper'>
//           {this.renderStep()}
//         </div>

//         {isLoading && <LoadingIcon />}

//         <Button
//           onClick={this.handleNextStep}
//           disabled={isLoading || authConnection.loading}
//           color="blue"
//           className="w-100 mb-4"
//         >
//           {isLoading ? <LoadingIcon /> : currentStep === 3 ? "Review Agreement to Register" : "Next"}
//         </Button>

//         {currentStep > 1 && (
//           <span
//             onClick={this.handlePreviousStep}
//             disabled={authConnection.loading}
//             className="previous-btn"
//           >
//             &lt;&lt; Previous
//           </span>
//         )}
//       </form>
//     );
//   }
// }

// RegisterForm.displayName = 'RegisterForm';

// RegisterForm.propTypes = {
//   registering: PropTypes.bool.isRequired,
//   privacyPolicySection: PropTypes.node, // Made optional as it's not directly used in this flow
//   handleSubmit: PropTypes.func.isRequired,
//   pristine: PropTypes.bool.isRequired,
//   submitting: PropTypes.bool.isRequired,
//   change: PropTypes.func.isRequired,
//   untouch: PropTypes.func.isRequired,
//   authConnection: PropTypes.object.isRequired,
//   isFromProvider: PropTypes.bool.isRequired, // Assuming this prop is still relevant to your app
//   onSuccessMessage: PropTypes.func,
//   onErrorMessage: PropTypes.func,
// };

// function mapDispatchToProps(dispatch) {
//   const actions = { getAuthConnection, signIn, resetConnection, loading, onboardOrg, onBoard, checkEmailExists };
//   return { actions: bindActionCreators(actions, dispatch) };
// }

// function mapStateToProps(state) {
//   return {
//     authConnection: authConnection(state),
//     unverifiedEmail: state.identity.unverifiedEmail,
//     identity: state.identity
//   };
// }

// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(reduxForm({
//   form: 'signin-register-reset',
//   destroyOnUnmount: false, // Keep form values when component unmounts temporarily (e.g., switching steps)
//   forceUnregisterOnUnmount: true // Unregister form when component is removed
// })(RegisterForm)));
